import { AlarmHistoryTable } from '../components/AlarmHistoryTable.js';
import { useMachineAlarms } from '../hooks/useMachineAlarms.js';

export interface AlarmsTabProps {
  readonly shopId: string | null;
  readonly machineId: string;
}

export function AlarmsTab({ shopId, machineId }: AlarmsTabProps): JSX.Element {
  const { alarms, isLoading } = useMachineAlarms(shopId, machineId);
  return <AlarmHistoryTable alarms={alarms} loading={isLoading} />;
}
